import { useQuery } from '@tanstack/react-query'

import { CAR_QUERY_KEYS } from '@/entities/car/lib'

import { getCarDetailModelList } from '../request/carApis'

import type { ICarDetailModel } from '@/entities/car/model'
const useCarDetailModelListQuery = (
  brandId: number | null,
  carId: number | null
) => {
  return useQuery<ICarDetailModel[]>({
    queryKey: CAR_QUERY_KEYS.CAR_DETAIL_MODEL.list(brandId!, carId!),
    queryFn: () => getCarDetailModelList(brandId!, carId!),
    enabled: !!brandId && !!carId,
    throwOnError: false,
  })
}

export default useCarDetailModelListQuery
